module.exports = __webpack_public_path__ + "img/sponge.0f8879f0.png";